"use client";

import { useMemo } from "react";
import { useGlobalConfig, useUserVip } from "@/stores/appStore";
import { getUploadConfig } from "../config/upload-config";
import { UploadConfig } from "../core/types";

export function useUploadConfig(overrides?: Partial<UploadConfig>) {
  const { globalConfig } = useGlobalConfig();
  const { vip } = useUserVip();

  return useMemo(() => {
    return getUploadConfig(globalConfig?.value ?? null, vip ?? 0, overrides);
  }, [globalConfig?.value, vip, overrides]);
}

